import { ToastContainer } from 'react-toastify';
import loading from '../../src/assets/images/loading.gif'
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "react-modal"
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { addSpacesToPascalCase, customStyles, formatWithCommas, getUserManual, truncateText } from 'helpers';
import { PageProps } from 'interfaces/index.types';
// import { useMsal } from '@azure/msal-react';

const Header = (props: PageProps) => {
    const { page } = props  
    const location = useLocation()
    const navigate = useNavigate();   
    const user:any = useSelector((state: any) => state.tepngUser.value);
    const roles:any = useSelector((state: any) => state.roles.value);    
    const unreadCount:number = useSelector((state: any) => state.unreadCount.value);    
    const [isLoading, ] = useState(false)
    
    // const { instance } = useMsal();
    const handleADLogout = () => {
        sessionStorage.removeItem("vendorCode") // to clear vendorCode
        const frontendUrl = process.env.REACT_APP_REDIRECT_URI
        // needed to logout of microsoft - the frond end url needs to be added to Azure App registration Redirect URIs to allow for logout redirect
        if(process.env.REACT_APP_LOGOUT_URL !== undefined && frontendUrl !== undefined) {
            window.location.replace(process.env.REACT_APP_LOGOUT_URL + frontendUrl);
        }        
    };

    const role = window.location.pathname.split('/')[1]
    const AllowedToViewNotifications = [
        "transitofficer",
        "freightforwarder",
        "localclearingagent",
        "supplier"
    ]   
    const [isShowRoleBox, setIsShowRoleBox] = useState(false)

    //close role-box on window scroll
    window.addEventListener('scroll', () => {
        setIsShowRoleBox(false)
    })

    const handleManualDownload = () => {
        const link = document.createElement('a');
        link.href = `/media/${getUserManual(role)}`;
        link.target = '_blank';
        link.click();
    };
    

    // const elelemnt = document.getElementById("role-box-trigger")
    // elelemnt?.addEventListener('mouseover', () => setIsShowRoleBox(true))
    // elelemnt?.addEventListener('mouseout', () => setIsShowRoleBox(false))

    return (
        <>
            <nav>
                <div className='nav-left'>
                    <div onClick={() => (document.getElementById("thenavbar") as HTMLElement)?.classList.toggle("active")} className="menu_btn"><span className="material-symbols-rounded" style={{color:"white"}}>menu</span></div>
                    <h4>{ page }</h4>
                </div>
               
                <div className='nav-right'>
                    <div id="role-box-trigger" style={{textAlign: "right"}}>
                        <p className='capitalize'>{user?.firstName} {roles.some((role: string) => role === "FreightForwarder" || role === "Supplier" || role === "LocalClearingAgent") ? "" : user?.lastName}</p>
                        <p className='f-10'>{addSpacesToPascalCase(truncateText((roles)?.join(", "), 70))}</p>

                        {roles.length > 1 && <span className='f-11 fw-600' onClick={() => setIsShowRoleBox(!isShowRoleBox)}
                            style={{cursor: "pointer", textDecoration: "underline"}}>Switch Roles</span>}
                    </div> 
                    <div className='user-manual'
                        onClick={handleManualDownload}
                        title='Click to view user manual'>
                        User Manual
                    </div>
                    <span onClick={() => alert('Contact our support team at "ep-ng-transittracker-helpdesk@totalenergies.com".')}
                        className="material-symbols-rounded" 
                        style={{color: "white", marginLeft: "8px", cursor: "pointer", borderLeft: "1px solid white", padding: "0 16px", height: "30px", display: "flex", alignItems: "center"}}
                    >support_agent</span>
                    {AllowedToViewNotifications.includes(role) && <button type="button" className="icon-button" style={{borderLeft: "1px solid white", padding: "0 16px"}}  onClick={() => navigate(`/${location.pathname.split('/')[1]}/notifications`)}>
                        <span className="material-symbols-rounded">notifications</span>
                        {unreadCount > 0 && <span className="icon-button__badge">{formatWithCommas(unreadCount)}</span>}
                    </button>}
                    <button className='white-text' style={{borderLeft: "1px solid white", paddingLeft: "16px", height: "30px"}} 
                        onClick={() => handleADLogout()}>Logout</button>
                </div>
            </nav>

            {/* to be removed */}
            {isShowRoleBox && 
            <div style={{position: "absolute", display: "flex", justifyContent: "space-between", width: "100%", height: "100vh", background: "rgba(0, 0, 0, 0.5"}}>
                <div></div>
            <div 
            id="role-box" 
            style={{
                // position: "absolute",
                // top: "64px",
                left: "0",
                // marginRight: "165px",
                padding: "16px",
                width: "220px",
                height: "100vh",
                backgroundColor: "white",
                zIndex: "1",
                borderRadius: "4px",
                boxShadow: "0px 4px 16px 0px rgba(0,0,0,0.2)"
            }}
            onClick={() => setIsShowRoleBox(false)}
            >
                

                <div className="d-flex">
                    <div>
                        <p style={{fontSize: "16px", margin: 0, marginTop: "12px", fontWeight: "500"}}>Roles</p>
                        <span className='f-11 text-grey'>Switch Current User Role</span>
                    </div>
                    <span className="material-symbols-rounded close" onClick={() => setIsShowRoleBox(false)}>close</span>
                </div>
                <p></p>
                {
                    roles.map((role: string) => {
                        return (
                            <div className='switch-roles' onClick={() => navigate(`/${role.toLowerCase().replaceAll(" ","")}/dashboard`)}>
                                {/* <div style={{height: "10px", width: "10px", backgroundColor: `${TRTRoles.find((data: any) => data.role === role)?.color}`}}></div> */}
                                <span style={{}}>{addSpacesToPascalCase(role)}</span>                                
                                <span className='text-green fw-600 f-11'>{window.location.pathname.split('/')[1] === role.toLocaleLowerCase().replaceAll(" ","") ? "Current" : ""}</span>                                
                            </div>
                        )
                    })
                }
            </div>
            </div>
            }
            
            <ToastContainer />
            <Modal isOpen={isLoading} style={customStyles} className="modal modal-sm" ariaHideApp={false}>
                <div className="loader">
                    <img src={loading} alt="loading" />
                    <p>Loading data...</p>
                </div>
            </Modal> 
        </>
    )
}

export default Header